import React, { useState, useEffect } from "react";
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from "../../assets/Icons/Cancel.svg";
import { toast } from "react-toastify";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import CachedIcon from "@mui/icons-material/Cached";
import FilterImg from "../../assets/Images/Funnel.svg";
import CustFilterModal from "../customer/CustFilterModal";
import Pagination from "../common/Pagination";

const defaultFilterData = {
  customerCode: "",
  gstNumber: "",
  status: [],
  fromDate: "",
  toDate: "",
  companyPanNumber: "",
  firstContactPersonMobileNo: "",
};
const DeleteConfirmationUser = ({
  isOpen,
  onClose,
  editData,
  fetchUserData,
  handleClose,
  mode,
  tableDataUser,
  setFormData,
  formData,
}) => {
  const [selectedRow, setSelectedRow] = useState({ code: "", name: "" });
  const [showFilters, setShowFilters] = useState(false);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [auditData, setAuditData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [submissionError, setSubmissionError] = useState("");

  const [rowError, setRowError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setSelectedRow({ code: "", name: "" });
      setRowError("");
    }
  }, [isOpen]);

  const loggedInUserName = sessionStorage.getItem("username");
  const pageSize = 10;

  // useEffect(() => {
  //   if (Array.isArray(tableDataUser) && tableDataUser.length > 0) {
  //     setCustomerData(tableDataUser);
  //   }
  // }, [tableDataUser]);

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const deleteUser = () => {
    const loggedInUserName = sessionStorage.getItem("username");
    const requestBody = {
      ...editData,
      username: loggedInUserName,
      status: "3",
    };

    axiosPostApi(apiList.DELETE_USER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          // toast.success("User deleted successfully!");
          CustomAlert({
            title: "Success",
            text: response?.data?.message || "User deleted successfully!",
            icon: "success",
            confirmButtonText: "Ok",
          });
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
          fetchUserData(1);
          onClose();
          handleClose();
        } else {
          CustomAlert({
            title: "Failed to delete user",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting user", error);
        toast.error("Failed to delete user.");
      })
      .finally(() => {
        onClose();
        handleClose();
      });
  };

  if (!isOpen) {
    return null;
  }

  const toggleFilters = () => {
    setShowFilters((prevState) => !prevState);
  };

  const handleToggle = () => {
    // toggleFilters();
    handleReset();
    setCustomerData([]);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const UserformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode) {
      activeFilters.push(`Company Id: ${filterData.customerCode}`);
    }
    if (filterData.gstNumber) {
      activeFilters.push(`GST No: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`Comp. Pan: ${filterData.companyPanNumber}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 +
          ", " +
          customer.address2 +
          ", " +
          customer.address3,
      }))
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const fetchCustomerData = async (currentPage, filterData) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        status: filterData.status || [],
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);

        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);

        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);

        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  // TODO
  const fetchCustAudit = async (custData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userCode: custData.customerCode,
      };

      const response = await axiosPostApi(
        `${apiList.CUST_AUDIT_DATA}`,
        requestBody
      );
      console.log("FetchCustAudit", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div
      className={`modal fade show ${
        mode === "delete" ? "modal-md" : "modal-xl"
      }`}
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        margin: 0,
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div
            className="modal-header"
            style={{ borderBottom: "none", justifyContent: "end", gap: "8px" }}
          >
            {mode !== "delete" && (
              <div className="filter-container">
                {showFilters && (
                  <motion.div
                    initial={{ x: "100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: "100%", opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="search-btn" onClick={openModalFilter}>
                      Search/Filter
                    </div>
                  </motion.div>
                )}

                {showFilters && (
                  <motion.div
                    initial={{ x: "100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: "100%", opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="green-btn" onClick={handleToggle}>
                      <CachedIcon />
                    </div>
                  </motion.div>
                )}

                <div className="filter-toggle-box">
                  <img
                    src={FilterImg}
                    alt="funnel"
                    className="funnel-icon"
                    onClick={toggleFilters}
                  />
                  <div
                    className={`filter-text ${
                      filterData && Object.keys(filterData).length > 0
                        ? "pr-1"
                        : ""
                    }`}
                  >
                    {filterData && UserformatFilterDisplay(filterData)}
                  </div>
                </div>
              </div>
            )}
            <span>
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div
            className="modal-body text-center"
            style={{ overflow: "scroll" }}
          >
            {mode === "delete" ? (
              <>
                <img
                  src={confirmDelete}
                  alt="Warning"
                  className="img-fluid mb-3"
                  style={{ width: "250px" }}
                />
                <h5 className="modal-title">
                  {mode === "delete" ? "Delete Confirmation" : "Data Table"}
                </h5>
                <p className="mt-2">
                  Information will be permanently erased and irretrievable.
                </p>
              </>
            ) : (
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th></th>
                      {/* <th>Code</th>
                      <th>Name</th>
                      <th>Email ID</th>
                      <th>Contact Person Name/ SPOC Name</th>
                      <th>Contact Person No. / SPOC Contact</th>
                      <th>City</th> */}
                      <th>Company Id</th>
                      <th>Company Name</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th>Company Email Id</th>
                      <th>Address</th>
                      <th>Contact Person Name</th>
                      <th>Contact Person Mobile No</th>
                      <th>Bank Name</th>
                      <th>Account Number</th>
                      <th>IFSC Code</th>
                      <th>GST Number</th>
                      <th>Company Pan</th>
                      <th>PAN Number</th>
                      <th>Aadhar Number</th>
                      <th>SMS Rate</th>
                      <th>RCS Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerData && customerData.length > 0 ? (
                      // customerData.map((row, index) => (
                      //   <tr key={index}>
                      //     <td>
                      //       <input
                      //         type="radio"
                      //         name="selectRow"
                      //         // onChange={() =>

                      //         //   setSelectedRow({
                      //         //     code:
                      //         //       row.customerCode ||
                      //         //       row.vendorId ||
                      //         //       row.retailerCode,
                      //         //     name: row.name || row.vendorName,
                      //         //   })
                      //         // }
                      //         onChange={() => {
                      //           const selectedCode =
                      //             row.customerCode ||
                      //             row.vendorId ||
                      //             row.retailerCode;
                      //           const selectedName = row.name || row.vendorName;

                      //           setSelectedRow({
                      //             code: selectedCode,
                      //             name: selectedName,
                      //           });

                      //           if (row.authStatus === "IN-ACTIVE") {
                      //             setRowError(
                      //               "Unable to create user: The selected company is inactive. Please activate it to proceed."
                      //             );
                      //           } else {
                      //             setRowError("");
                      //           }
                      //         }}
                      //         checked={
                      //           selectedRow.code ===
                      //           (row.customerCode ||
                      //             row.vendorId ||
                      //             row.retailerCode)
                      //         }
                      //       />
                      //     </td>
                      //     {/* <td>
                      //       {row.customerCode ||
                      //         row.vendorId ||
                      //         row.retailerCode}
                      //     </td>
                      //     <td>{row.name || row.vendorName}</td>
                      //     <td>{row.emailId || "--"}</td>
                      //     <td>{row.firstContactPersonName || row.spocName}</td>
                      //     <td>
                      //       {row.firstContactPersonMobileNo ||
                      //         row.spocContactNo}
                      //     </td>
                      //     <td>{row.city || row.vendorAddress}</td> */}

                      //     <td>{row?.customerCode}</td>
                      //     <td>{row?.name}</td>
                      //     <td>{row?.authStatus}</td>
                      //     <td>{row?.adminRemark}</td>
                      //     <td>{row?.emailId}</td>
                      //     <td>{row?.address}</td>
                      //     <td>{row?.firstContactPersonName}</td>
                      //     <td>{row?.firstContactPersonMobileNo}</td>
                      //     <td>{row?.bankName}</td>
                      //     <td>{row?.accountNo}</td>
                      //     <td>{row?.ifscCode}</td>
                      //     <td>{row?.gstNumber}</td>
                      //     <td>{row?.companyPanNumber}</td>
                      //     <td>{row?.panNumber}</td>
                      //     <td>{row?.aadharNumber}</td>
                      //     <td>{row?.rate}</td>
                      //     <td>{row?.rcsRate}</td>
                      //   </tr>
                      // ))
                      customerData.map((row, index) => {
                        const currentCode =
                          row.customerCode || row.vendorId || row.retailerCode;

                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                <input
                                  type="radio"
                                  name="selectRow"
                                  onChange={() => {
                                    const selectedCode = currentCode;
                                    const selectedName =
                                      row.name || row.vendorName;

                                    setSelectedRow({
                                      code: selectedCode,
                                      name: selectedName,
                                    });

                                    if (row.authStatus === "IN-ACTIVE") {
                                      setRowError(
                                        "Unable to create user: The selected company is inactive. Please activate it to proceed."
                                      );
                                    } else {
                                      setRowError("");
                                    }
                                  }}
                                  checked={selectedRow.code === currentCode}
                                />
                              </td>

                              <td>{row?.customerCode}</td>
                              <td>{row?.name}</td>
                              <td>{row?.authStatus}</td>
                              <td>{row?.adminRemark}</td>
                              <td>{row?.emailId}</td>
                              <td>{row?.address}</td>
                              <td>{row?.firstContactPersonName}</td>
                              <td>{row?.firstContactPersonMobileNo}</td>
                              <td>{row?.bankName}</td>
                              <td>{row?.accountNo}</td>
                              <td>{row?.ifscCode}</td>
                              <td>{row?.gstNumber}</td>
                              <td>{row?.companyPanNumber}</td>
                              <td>{row?.panNumber}</td>
                              <td>{row?.aadharNumber}</td>
                              <td>{row?.rate}</td>
                              <td>{row?.rcsRate}</td>
                            </tr>

                            {rowError && selectedRow.code === currentCode && (
                              <tr>
                                <td colSpan="18">
                                  <div
                                    className="alert alert-danger text-start"
                                    role="alert"
                                    style={{ margin: 0 }}
                                  >
                                    {rowError}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="2">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}

            {mode !== "delete" && totalRecord > 10 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination
                  currentPage={currentPage}
                  totalCount={totalRecord}
                  pageSize={pageSize}
                  onPageChange={(page) => {
                    setCurrentPage(page);
                    fetchCustomerData(page, filterData);
                  }}
                />
              </div>
            )}
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-back"
              data-bs-dismiss="modal"
              onClick={() => {
                onClose();
                handleReset();
                setCustomerData([]);
                setPageDetails(null);
                setSelectedRow({ code: "", name: "" }); // ⬅ reset selection
                setRowError(""); // ⬅ clear error if any
              }}
            >
              Cancel
            </button>

            {mode === "delete" ? (
              <button
                type="button"
                className="btn btn-danger"
                onClick={deleteUser}
              >
                Delete Permanently
              </button>
            ) : (
              // <button
              //   type="button"
              //   className="btn btn-submit"
              //   onClick={() => {
              //     setFormData({
              //       ...formData,
              //       userCode: selectedRow.code,
              //       selectedName: selectedRow.name,
              //     });
              //     onClose();
              //   }}
              // >
              //   Submit
              // </button>

              <button
                type="button"
                className="btn btn-submit"
                onClick={() => {
                  const selectedCompany = customerData.find(
                    (row) =>
                      selectedRow.code ===
                      (row.customerCode || row.vendorId || row.retailerCode)
                  );

                  if (selectedCompany?.authStatus === "IN-ACTIVE") {
                    setSubmissionError(
                      "Unable to create user: The selected company is inactive. Please activate it to proceed."
                    );
                    return;
                  }

                  setFormData({
                    ...formData,
                    userCode: selectedRow.code,
                    selectedName: selectedRow.name,
                  });
                  setSubmissionError(""); // Clear error if previously shown
                  onClose();
                }}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      {isModalOpenFilter ? (
        <CustFilterModal
          show={isModalOpenFilter}
          handleClose={closeModalFilter}
          auditData={auditData}
          setCustomerData={setCustomerData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSize}
          filterData={filterData}
          setFilterData={setFilterData}
          handleReset={handleReset}
          text="AddUser"
        />
      ) : null}
    </div>
  );
};

export default DeleteConfirmationUser;
